import React from "react";
import winnersImg from "../../Images/Rectangle 12.png";
import winnerAboutImg from "../../Images/Group 40 (2).png";
import winnerAboutImage from "../../Images/Group 7.png";
import img from "../../Images/Rectangle 16.png";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
const AboutWinners = () => {
  const navigate = useNavigate();
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1299,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="wall_of_fame_wrapper">
        <div className="search_cities_div">
          <div className="winners_head_wrapper4566">
            <h1>About Winners</h1>
            <div className="about_winners_video_wrapper">
              <div className="about_winers_video_img">
                <img
                  src={winnersImg}
                  alt="winners"
                  className="winners_video_img46626"
                />
                {/* <i class="fa-solid fa-play"></i> */}
              </div>
              <p>
                Each listing offers unique features, exceptional quality, and
                prime locations
              </p>
            </div>
          </div>
          <div className="winners_content_wrapper4566">
            <div className="winers_img_left">
              <img
                className="winners_img4569789"
                alt="building"
                src={winnerAboutImage}
              />
            </div>
            <div className="winners_content_right">
              <div className="winners_content_card_Wrapper">
                <Slider {...settings}>
                  <div className="winners_content_card">
                    <div className="winners_card_content45465463">
                      <h3>Big things can happen in small spaces</h3>
                      <p>
                        With thoughtful design and smart organization, you can
                        maximize every inch, making room for creativity
                      </p>
                      {/* <button onClick={() => navigate("/aboutus")}>
                        Learn More
                      </button> */}
                    </div>
                  </div>
                  <div className="winners_content_card">
                    <img src={img} />
                    <span>Pricing Start at $256k</span>
                    {/* <button>Explore Properties</button> */}
                  </div>
                </Slider>
              </div>
              <div className="winners_content_arrow_wrapper">
                <p>
                  Whether it’s creating a cozy corner for relaxation or
                  transforming a small area into a workspace
                </p>
                {/* <div className="arrow_wrapper1623232323">
                  <i class="fa-solid fa-arrow-left"></i>
                  <i class="fa-solid fa-arrow-right"></i>
                </div> */}
              </div>
            </div>
          </div>
          <div className="winners_countdown_wrapper46646">
            <div className="winners_countdown13565">
              <h3>1 Lakh</h3>
              <p style={{ marginTop: "10px" }}>Active Properties</p>
            </div>
            <div className="winners_countdown13565">
              <h3>25 Crore</h3>
              <p>Inactive Property</p>
            </div>
            <div className="winners_countdown13565">
              <h3>20+</h3>
              <p>Cities</p>
            </div>
            <div className="winners_countdown13565">
              <h3>1600+</h3>
              <p>Localities</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutWinners;
